import React from 'react'
import styles from './status-desc.styles'
import injectSheet from 'react-jss'

const StatusDesc = ({ classes, children }) => (
  <div className={classes.container}>
    <p>{children}</p>
  </div>
)

export default injectSheet(styles)(StatusDesc)
